import chain from '@/lib/axios-chain'

// 提交我的便签
export const subWorkLog = () => chain.create('/user/worklog/addlog', 'post')
// 获取通知记录
export const getNoticeList = () => chain.create('/user/notice/index', 'get')
// 更新通知阅读状态
export const updateNoticeReadStatus = () => chain.create('/user/notice/setread', 'post')
// 初始化获取我的便签内容
export const getWorkLogoDetail = () => chain.create('/user/worklog/detail', 'get')
